import { render } from "./TaskActionList.vue?vue&type=template&id=c5ca9e92&ts=true"
import script from "./TaskActionList.vue?vue&type=script&lang=ts"
export * from "./TaskActionList.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__